<template>
  <v-container>
    <v-card flat>
      <!-- Used to display company employee permissions with type employed -->
      <CompanyEmployeeList nextTo="CompanyEmployeePermissions" :isDepartments="hasDepartments($route.params.id)" :MessageBoxText="$t('company.department-roles-info') + ' ' + getCurrentUserDepartments($route.params.id)" type="employed" :title="$t('labels.roles')"/>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import CompanyEmployeeList from '@/components/Company/CompanyEmployeeList'
import { CompanyRoles } from '@/components/mixins'
// @group Company
// CompanyPermissions component

export default {
  name: 'CompanyPermissions',

  mixins: [CompanyRoles],

  components: {
    CompanyEmployeeList,
  },

  data: () => ({
    tab: null,

    apprentice: {}
  }),

  computed: {
    ...mapGetters('currentuser', ['currentUser'])
  },

  created() {}
}
</script>

<style lang="scss"></style>
